import {z} from "../../../lib";
import {schemaEntityWithIdAndDescription} from "../../../types";

export const SistemaFields = {
    SistemaPrincipal: 'sistemaPrincipal',
    SistemaTipo: 'sistemaTipo',
} as const

export const schemaSistema = z
    .object({
        [SistemaFields.SistemaPrincipal]: z.number(),
        [SistemaFields.SistemaTipo]: z.number(),
    })
    .merge(schemaEntityWithIdAndDescription)

export type Sistema = z.infer<typeof schemaSistema>
